import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const truckTypesAdapter = getAdapter({ idFieldName: 'value' });

const truckTypesSlice = createSlice({
  name: 'truckTypes',
  initialState: truckTypesAdapter.getInitialState(),
  reducers: {
    setTruckTypes: (state, { payload: { truckTypes } }) => {
      truckTypesAdapter.setAll(state, truckTypes);
    },
  },
});

const selectors = truckTypesAdapter.getSelectors(({ truckTypes }) => truckTypes);

export const getTruckTypesIncludingDeleted = (state) => selectors.selectAll(state);

export const getTruckTypes = (state) => getTruckTypesIncludingDeleted(state)
  .filter(({ deleted }) => !deleted);

export const {
  setTruckTypes,
} = truckTypesSlice.actions;

export default truckTypesSlice.reducer;
